// Define channel-specific items with their associated channel types
const CHANNEL_SPECIFIC_ITEMS = {
  'create_the_campaign_facebook': 'facebook',
  'assign_creatives_facebook': 'facebook',
  'upload_creatives_facebook': 'facebook',
  'create_the_campaign_gam': 'google-ad-manager',
  'create_the_campaign_google_search': 'google-ads-search',
  'assign_creatives_google_search': 'google-ads-search',
  'upload_creatives_google_search': 'google-ads-search',
  'create_the_campaign_google_display': 'google-ads-display',
  'assign_creatives_google_display': 'google-ads-display',
  'upload_creatives_google_display': 'google-ads-display',
  'create_the_campaign_google_pmax': 'google-ads-pmax',
  'assign_creatives_google_pmax': 'google-ads-pmax',
  'upload_creatives_google_pmax': 'google-ads-pmax',
  'create_the_campaign_google_demandgen': 'google-ads-demandgen',
  'assign_creatives_google_demandgen': 'google-ads-demandgen',
  'upload_creatives_google_demandgen': 'google-ads-demandgen',
  'create_the_campaign_tiktok': 'tiktok',
  'create_the_campaign_madhive': 'madhive',
  'create_the_campaign_amazon_dsp': 'amazon-dsp',
  'create_the_campaign_yahoo': 'yahoo',
  'optimize_yahoo_campaign': 'yahoo',
  'create_the_campaign_universal_ads': 'universal-ads',
  'fast_track_shell_universal_ads': 'universal-ads',
  'create_the_campaign_dv360': 'dv360',
  'assign_creatives_dv360': 'dv360',
  'upload_creatives_dv360': 'dv360',
  'analyze_dv360_campaign': 'dv360',
  'optimize_dv360_campaign': 'dv360',
  'execute_dv360_optimization': 'dv360',
  'qa_dv360_campaign': 'dv360',
  'create_the_campaign_ttd': 'ttd',
  'assign_creatives_ttd': 'ttd',
  'create_the_campaign_groundtruth': 'groundtruth',
  'upload_creatives_ttd': 'ttd',
  'analyze_ttd_campaign': 'ttd',
  'optimize_ttd_campaign': 'ttd',
  'execute_ttd_optimization': 'ttd',
  'qa_ttd_campaign': 'ttd',
  'create_the_campaign_reddit': 'reddit',
  'create_the_campaign_openai': 'openai',
  'assign_creatives_openai': 'openai',
  'assign_creatives_reddit': 'reddit',
  'upload_creatives_reddit': 'reddit',
  'analyze_reddit_campaign': 'reddit',
  'optimize_reddit_campaign': 'reddit',
  'execute_reddit_optimization': 'reddit',
  'qa_reddit_campaign': 'reddit',
  'create_the_campaign_linkedin': 'linkedin',
  'assign_creatives_linkedin': 'linkedin',
  'upload_creatives_linkedin': 'linkedin',
  'analyze_linkedin_campaign': 'linkedin',
  'optimize_linkedin_campaign': 'linkedin',
  'execute_linkedin_optimization': 'linkedin',
  'qa_linkedin_campaign': 'linkedin',
  'analyze_facebook_campaign': 'facebook',
  'optimize_facebook_campaign': 'facebook',
  'refresh_facebook_campaign': 'facebook',
  'allocate_budget': 'cross-platform',
  'create_salesforce_opportunity': 'salesforce',
  'copy_facebook_campaign': 'facebook',
  'enable_campaign_monitoring_facebook': 'facebook',
  'enable_campaign_monitoring_gam': 'google-ad-manager',
  'enable_campaign_monitoring_tiktok': 'tiktok',
  'enable_campaign_monitoring_amazon_dsp': 'amazon-dsp',
  'get_impression_reporting_facebook': 'facebook',
  'get_impression_reporting_tiktok': 'tiktok',
  'get_impression_reporting_amazon_dsp': 'amazon-dsp',
  'fast_track_facebook': 'facebook',
  'fast_track_google_search': 'google-ads',
  'fast_track_google_display': 'google-ads',
  'fast_track_google_pmax': 'google-ads',
  'fast_track_google_demandgen': 'google-ads',
  'fast_track_tiktok': 'tiktok',
  'fast_track_madhive': 'madhive',
  'fast_track_dv360': 'dv360',
  'fast_track_ttd': 'ttd',
  'fast_track_reddit': 'reddit',
  'fast_track_openai': 'openai',
  'fast_track_linkedin': 'linkedin',
  'fast_track_salesforce_opportunity': 'salesforce',
  'fast_track_shell_facebook': 'facebook',
  'fast_track_shell_gam': 'google-ad-manager',
  'fast_track_shell_google_search': 'google-ads',
  'fast_track_shell_google_display': 'google-ads',
  'fast_track_shell_google_pmax': 'google-ads',
  'fast_track_shell_google_demandgen': 'google-ads',
  'fast_track_shell_tiktok': 'tiktok',
  'fast_track_shell_madhive': 'madhive',
  'fast_track_shell_dv360': 'dv360',
  'fast_track_shell_ttd': 'ttd',
  'fast_track_shell_reddit': 'reddit',
  'fast_track_shell_openai': 'openai',
  'fast_track_shell_linkedin': 'linkedin',
  'fast_track_shell_amazon_dsp': 'amazon-dsp',
  'fast_track_shell_yahoo': 'yahoo'
};

// All dropdown items
const ALL_DROPDOWN_ITEMS = [
    { id: 'upload_an_insertion_order', text: 'Upload an Insertion Order', icon: 'upload_file' },
    { id: 'update_campaign_details', text: 'Update Campaign Details', icon: 'edit_note' },
    { id: 'process_creative_assets', text: 'Process Creative Assets', icon: 'image' },
    { id: 'update_creative_details', text: 'Update Creative Details', icon: 'edit_note' },
    { id: 'apply_launch_configuration', text: 'Apply the Launch Configuration', icon: 'rocket_launch' },
    { id: 'update_configuration_details', text: 'Update Launch Configuration details', icon: 'edit_note' },
    { id: 'create_the_campaign_facebook', text: 'Create the Campaign (Facebook)', icon: 'thumb_up' },
    { id: 'assign_creatives_facebook', text: 'Assign Creatives to Facebook Campaign', icon: 'thumb_up' },
    { id: 'upload_creatives_facebook', text: 'Upload Creatives to Facebook', icon: 'upload' },
    { id: 'create_the_campaign_gam', text: 'Create the Campaign (Google Ad Manager)', icon: 'ad_units' },
    { id: 'create_the_campaign_google_search', text: 'Create the Campaign (Google Search)', icon: 'search' },
    { id: 'assign_creatives_google_search', text: 'Assign Creatives to Google Search Campaign', icon: 'search' },
    { id: 'upload_creatives_google_search', text: 'Upload Creatives to Google Search', icon: 'upload' },
    { id: 'create_the_campaign_google_display', text: 'Create the Campaign (Google Display)', icon: 'view_carousel' },
    { id: 'assign_creatives_google_display', text: 'Assign Creatives to Google Display Campaign', icon: 'view_carousel' },
    { id: 'upload_creatives_google_display', text: 'Upload Creatives to Google Display', icon: 'upload' },
    { id: 'create_the_campaign_google_pmax', text: 'Create the Campaign (Google PMax)', icon: 'ads_click' },
    { id: 'assign_creatives_google_pmax', text: 'Assign Creatives to Google PMax Campaign', icon: 'ads_click' },
    { id: 'upload_creatives_google_pmax', text: 'Upload Creatives to Google PMax', icon: 'upload' },
    { id: 'create_the_campaign_google_demandgen', text: 'Create the Campaign (Google DemandGen)', icon: 'auto_awesome' },
    { id: 'assign_creatives_google_demandgen', text: 'Assign Creatives to Google DemandGen Campaign', icon: 'auto_awesome' },
    { id: 'upload_creatives_google_demandgen', text: 'Upload Creatives to Google DemandGen', icon: 'upload' },
    { id: 'create_the_campaign_tiktok', text: 'Create the Campaign (TikTok)', icon: 'music_note' },
    { id: 'create_the_campaign_madhive', text: 'Create the Campaign (MadHive)', icon: 'tv' },
    { id: 'create_the_campaign_amazon_dsp', text: 'Create the Campaign (Amazon DSP)', icon: 'shopping_cart' },
    { id: 'create_the_campaign_universal_ads', text: 'Create the Campaign (Universal Ads)', icon: 'live_tv' },
    { id: 'fast_track_shell_universal_ads', text: 'Fast Track Campaign Shell (Universal Ads)', icon: 'speed' },
    { id: 'create_the_campaign_yahoo', text: 'Create the Campaign (Yahoo DSP)', icon: 'ads_click' },
    { id: 'optimize_yahoo_campaign', text: 'Optimize Yahoo Campaign', icon: 'tune' },
    { id: 'create_the_campaign_dv360', text: 'Create the Campaign (DV360)', icon: 'smart_display' },
    { id: 'assign_creatives_dv360', text: 'Assign Creatives to DV360 Campaign', icon: 'smart_display' },
    { id: 'upload_creatives_dv360', text: 'Upload Creatives to DV360', icon: 'upload' },
    { id: 'analyze_dv360_campaign', text: 'Analyze DV360 Campaign', icon: 'analytics' },
    { id: 'optimize_dv360_campaign', text: 'Optimize DV360 Campaign', icon: 'tune' },
    { id: 'plan_dv360_campaign', text: 'Plan DV360 Campaign', icon: 'strategy' },
    { id: 'execute_dv360_optimization', text: 'Execute DV360 Campaign Optimization Recommendation', icon: 'play_arrow' },
    { id: 'qa_dv360_campaign', text: 'QA DV360 Campaign', icon: 'fact_check' },
    { id: 'create_the_campaign_ttd', text: 'Create the Campaign (TTD)', icon: 'campaign' },
    { id: 'assign_creatives_ttd', text: 'Assign Creatives to TTD Campaign', icon: 'campaign' },
    { id: 'create_the_campaign_groundtruth', text: 'Create the Campaign (GroundTruth)', icon: 'location_on' },
    { id: 'upload_creatives_ttd', text: 'Upload Creatives to TTD', icon: 'upload' },
    { id: 'analyze_ttd_campaign', text: 'Analyze TTD Campaign', icon: 'analytics' },
    { id: 'optimize_ttd_campaign', text: 'Optimize TTD Campaign', icon: 'tune' },
    { id: 'execute_ttd_optimization', text: 'Execute TTD Campaign Optimization Recommendation', icon: 'play_arrow' },
    { id: 'qa_ttd_campaign', text: 'QA TTD Campaign', icon: 'fact_check' },
    { id: 'create_the_campaign_reddit', text: 'Create the Campaign (Reddit)', icon: 'forum' },
    { id: 'create_the_campaign_openai', text: 'Create the Campaign (OpenAI)', icon: 'smart_toy' },
    { id: 'assign_creatives_openai', text: 'Assign Creatives to OpenAI Campaign', icon: 'image' },
    { id: 'assign_creatives_reddit', text: 'Assign Creatives to Reddit Campaign', icon: 'image' },
    { id: 'upload_creatives_reddit', text: 'Upload Creatives for Reddit Campaign', icon: 'upload' },
    { id: 'analyze_reddit_campaign', text: 'Analyze Reddit Campaign', icon: 'analytics' },
    { id: 'optimize_reddit_campaign', text: 'Optimize Reddit Campaign', icon: 'tune' },
    { id: 'execute_reddit_optimization', text: 'Execute Reddit Optimization', icon: 'play_arrow' },
    { id: 'qa_reddit_campaign', text: 'QA Reddit Campaign', icon: 'fact_check' },
    { id: 'create_the_campaign_linkedin', text: 'Create the Campaign (LinkedIn)', icon: 'work' },
    { id: 'assign_creatives_linkedin', text: 'Assign Creatives to LinkedIn Campaign', icon: 'image' },
    { id: 'upload_creatives_linkedin', text: 'Upload Creatives for LinkedIn Campaign', icon: 'upload' },
    { id: 'analyze_linkedin_campaign', text: 'Analyze LinkedIn Campaign', icon: 'analytics' },
    { id: 'optimize_linkedin_campaign', text: 'Optimize LinkedIn Campaign', icon: 'tune' },
    { id: 'execute_linkedin_optimization', text: 'Execute LinkedIn Optimization', icon: 'play_arrow' },
    { id: 'qa_linkedin_campaign', text: 'QA LinkedIn Campaign', icon: 'fact_check' },
    { id: 'analyze_facebook_campaign', text: 'Analyze Facebook Campaign', icon: 'analytics' },
    { id: 'optimize_facebook_campaign', text: 'Optimize Facebook Campaign', icon: 'tune' },
    { id: 'allocate_budget', text: 'Cross Channel Budget Allocation', icon: 'account_balance' },
    { id: 'create_salesforce_opportunity', text: 'Create Salesforce Opportunity', icon: 'cloud' },
    { id: 'copy_facebook_campaign', text: 'Copy Facebook Campaign', icon: 'content_copy' },
    { id: 'enable_campaign_monitoring_facebook', text: 'Enable Campaign Monitoring (Facebook)', icon: 'visibility' },
    { id: 'enable_campaign_monitoring_gam', text: 'Enable Campaign Monitoring (Google Ad Manager)', icon: 'visibility' },
    { id: 'enable_campaign_monitoring_tiktok', text: 'Enable Campaign Monitoring (TikTok)', icon: 'visibility' },
    { id: 'enable_campaign_monitoring_amazon_dsp', text: 'Enable Campaign Monitoring (Amazon DSP)', icon: 'visibility' },
    { id: 'get_impression_reporting_facebook', text: 'Get Impression Reporting (Facebook)', icon: 'analytics' },
    { id: 'get_impression_reporting_tiktok', text: 'Get Impression Reporting (TikTok)', icon: 'analytics' },
    { id: 'get_impression_reporting_amazon_dsp', text: 'Get Impression Reporting (Amazon DSP)', icon: 'analytics' },
    { id: 'generate_screenshots', text: 'Generate Screenshots', icon: 'screenshot' },
    { id: 'upload_a_media_plan', text: 'Upload a Media Plan', icon: 'insert_drive_file' },
    { id: 'process_media_briefs', text: 'Process Media Briefs', icon: 'description' },
    { id: 'fast_track_facebook', text: 'Fast Track Campaign (Facebook)', icon: 'speed' },
    { id: 'fast_track_google_search', text: 'Fast Track Campaign (Google Search)', icon: 'speed' },
    { id: 'fast_track_google_display', text: 'Fast Track Campaign (Google Display)', icon: 'speed' },
    { id: 'fast_track_google_pmax', text: 'Fast Track Campaign (Google PMax)', icon: 'speed' },
    { id: 'fast_track_google_demandgen', text: 'Fast Track Campaign (Google DemandGen)', icon: 'speed' },
    { id: 'fast_track_tiktok', text: 'Fast Track Campaign (TikTok)', icon: 'speed' },
    { id: 'fast_track_madhive', text: 'Fast Track Campaign (MadHive)', icon: 'speed' },
    { id: 'fast_track_dv360', text: 'Fast Track Campaign (DV360)', icon: 'speed' },
    { id: 'fast_track_ttd', text: 'Fast Track Campaign (TTD)', icon: 'speed' },
    { id: 'fast_track_reddit', text: 'Fast Track Campaign (Reddit)', icon: 'speed' },
    { id: 'fast_track_openai', text: 'Fast Track Campaign (OpenAI)', icon: 'speed' },
    { id: 'fast_track_linkedin', text: 'Fast Track Campaign (LinkedIn)', icon: 'speed' },
    { id: 'fast_track_salesforce_opportunity', text: 'Fast Track Salesforce Opportunity', icon: 'speed' },
    { id: 'fast_track_shell_facebook', text: 'Fast Track Campaign Shell (Facebook)', icon: 'speed' },
    { id: 'fast_track_shell_gam', text: 'Fast Track Campaign Shell (Google Ad Manager)', icon: 'speed' },
    { id: 'fast_track_shell_google_search', text: 'Fast Track Campaign Shell (Google Search)', icon: 'speed' },
    { id: 'fast_track_shell_google_display', text: 'Fast Track Campaign Shell (Google Display)', icon: 'speed' },
    { id: 'fast_track_shell_google_pmax', text: 'Fast Track Campaign Shell (Google PMax)', icon: 'speed' },
    { id: 'fast_track_shell_google_demandgen', text: 'Fast Track Campaign Shell (Google DemandGen)', icon: 'speed' },
    { id: 'fast_track_shell_tiktok', text: 'Fast Track Campaign Shell (TikTok)', icon: 'speed' },
    { id: 'fast_track_shell_madhive', text: 'Fast Track Campaign Shell (MadHive)', icon: 'speed' },
    { id: 'fast_track_shell_dv360', text: 'Fast Track Campaign Shell (DV360)', icon: 'speed' },
    { id: 'fast_track_shell_ttd', text: 'Fast Track Campaign Shell (TTD)', icon: 'speed' },
    { id: 'fast_track_shell_reddit', text: 'Fast Track Campaign Shell (Reddit)', icon: 'speed' },
    { id: 'fast_track_shell_openai', text: 'Fast Track Campaign Shell (OpenAI)', icon: 'speed' },
    { id: 'fast_track_shell_linkedin', text: 'Fast Track Campaign Shell (LinkedIn)', icon: 'speed' },
    { id: 'fast_track_shell_amazon_dsp', text: 'Fast Track Campaign Shell (Amazon DSP)', icon: 'speed' },
    { id: 'fast_track_shell_yahoo', text: 'Fast Track Campaign Shell (Yahoo DSP)', icon: 'speed' }
];

// Function to filter dropdown items based on enabled channels.
// options.hideUploadCreatives drops every "Upload Creatives to <platform>"
// item (account-level `hide-upload-creatives` setting).
export const getDropdownItems = (enabledChannels = {}, options = {}) => {
  const baseItems = options.hideUploadCreatives
    ? ALL_DROPDOWN_ITEMS.filter(item => !item.id.startsWith('upload_creatives_'))
    : ALL_DROPDOWN_ITEMS;

  // If no enabledChannels provided, return all non-channel-specific items
  if (!enabledChannels || Object.keys(enabledChannels).length === 0) {
    // Return only items that are not channel-specific
    return baseItems.filter(item => !CHANNEL_SPECIFIC_ITEMS[item.id]);
  }

  // Filter items based on enabled channels
  return baseItems.filter(item => {
    // If the item is not channel-specific, always include it
    if (!CHANNEL_SPECIFIC_ITEMS[item.id]) {
      return true;
    }

    const requiredChannel = CHANNEL_SPECIFIC_ITEMS[item.id];

    // Special handling for cross-platform features
    if (requiredChannel === 'cross-platform') {
      // Show cross-platform features if user has both DV360 and TTD channels
      return enabledChannels['dv360'] && enabledChannels['ttd'];
    }

    // Otherwise, check if the associated channel is enabled
    return enabledChannels[requiredChannel];
  });
};

// For backward compatibility, export the full list as DROPDOWN_ITEMS
export const DROPDOWN_ITEMS = ALL_DROPDOWN_ITEMS;

export const SUPPORTED_ACTIONS = [
    'creative-processor',
    'creative-augmentor',
    'campaign-processor',
    'campaign-augmentor',
    'campaign-launcher',
    'launch-augmentor',
    'fb-api',
    'gam-api',
    'campaign-audit',
    'fb-campaign-auditor',
    'gam-campaign-auditor',
    'media-brief-processor',
    'screenshot-builder',
    'g-ads-api',
    'ask-assistant',
    'tiktok-api',
    'madhive-api',
    'linkedin-api',
    'assign-creatives',
    'upload-creatives',
    'dv360-api',
    'ttd-api',
    'youtube-dv360-api',
    'gt-api',
    'reddit-api',
    'openai-api',
    'amazon-dsp-api',
    'yahoo-api',
    'universal-ads-api',
    'salesforce-api',
    'salesforce-orchestration',
    'fast-track',
    'fast-track-shell',
    'assign-creatives',
    'upload-creatives',
    'analyze-campaign',
    'optimize-campaign',
    'plan-campaign',
    'optimization-executor',
    'qa-campaign',
    'allocate-budget',
    'edit-campaign',
    'refresh-campaign'
  ];


// Follow up message mapping
export const FOLLOW_UP_MESSAGES = {
    'campaign-processor': ["View and compare with the original insertion order",
                           "Confirm the retrieved details from this insertion order",
                           "Export the details",
                           "Update campaign details",
                           "Process creative assets"],
    'campaign-augmentor': ["Update more campaign details",
                           "Process creative assets"],
    'creative-processor': ["View and compare with source data",
                           "Confirm the processed output",
                           "Assign creatives to campaign"],
    'creative-augmentor': ["Update more creative details"],
    'campaign-launcher': ["Confirm the launch template",
                          "Ask the Assistant to make changes",
                          "Create the Campaign"],
    'launch-augmentor': ["Confirm the launch template",
                            "Ask the Assistant to make changes",
                            "Create the Campaign"],
    'fb-api__copy-campaign': ["Generate screenshot",
                              "Add monitoring",
                              "Get reporting"],
    'fb-api__create-campaign': ["Generate screenshot",
                                "Add monitoring",
                                "Get reporting"],
    'gam-api__create-campaign': ["Generate screenshot",
                                 "Add monitoring",
                                 "Get reporting"],
    'g-ads-api__create-display-campaign': ["Generate screenshot",
                                   "Add monitoring",
                                   "Get reporting"],
    'g-ads-api__create-pmax-campaign': ["Generate screenshot",
                                   "Add monitoring",
                                   "Get reporting"],
    'g-ads-api__create-demandgen-campaign': ["Generate screenshot",
                                   "Add monitoring",
                                   "Get reporting"],
    'g-ads-api__create-search-campaign': ["Generate screenshot",
                                   "Add monitoring",
                                   "Get reporting"],
    'tiktok-api__create-campaign': ["Generate screenshot",
                                   "Add monitoring",
                                   "Get reporting"],
    'dv360-api__create-campaign': ["Generate screenshot",
                                    "Add monitoring",
                                    "Get reporting"],
    'youtube-dv360-api__create-campaign': ["Generate screenshot",
                                           "Add monitoring",
                                           "Get reporting"],
    'ttd-api__create-campaign': ["Generate screenshot",
                                    "Add monitoring",
                                    "Get reporting"],
    'gt-api__create-campaign': ["Generate screenshot",
                                    "Add monitoring",
                                    "Get reporting"],
    'reddit-api__create-campaign': ["Generate screenshot",
                                    "Add monitoring",
                                    "Get reporting"],
    'openai-api__create-campaign': ["Generate screenshot",
                                    "Add monitoring",
                                    "Get reporting"],
    'amazon-dsp-api__create-campaign': ["Generate screenshot",
                                   "Add monitoring",
                                   "Get reporting"],
    'universal-ads-api__create-campaign': ['Generate screenshot'],
    'yahoo-api__create-campaign': ["Generate screenshot"],
    'salesforce-api__create-opportunity': ["View opportunity details",
                                   "Create another opportunity"],
    'salesforce-orchestration': ["View opportunity details",
                                   "Create another opportunity"],
    'fast-track': ["Generate screenshot",
                  "Add monitoring",
                  "Get reporting",
                  "Ask the Assistant about this campaign"]
};